import * as pmrpc from 'pm-rpc'
import {setAPI} from '../privates/editorAPI'

export const initRPC = (namespace, target) => {
  return pmrpc.api
    .request(namespace, target ? {target} : undefined)
    .then(setAPI)
}
